import React, { useState } from 'react';
import './styles/Header.scss';
import { Close, MenuBookOutlined } from '@mui/icons-material';
// import { Link } from 'react-router-dom';

const Header = () => {
    const [active, setActive] = useState(false);
    const showMenu = () => {
        setActive(!active);
    }

    const closeMenu = () => {
        setActive(false);
    }

    return (
        <div className='header'>
            <div className='header__logo'>
                <h1>HS</h1>
            </div>
            <nav className={`navbar ${active ? 'active' : ''}`}>
                <ul>
                    <div className='closed'>
                        <Close className='close' onClick={ showMenu } />
                    </div>
                    <li>
                        <a href='#about' onClick={closeMenu}><b> About </b></a>
                        {/* <Link to='/'><b> About </b></Link> */}
                    </li>
                    <li>
                        <a href='#skills' onClick={closeMenu}><b> Skills </b></a>
                        {/* <Link to='/'><b> Skills </b></Link> */}
                    </li>
                    <li>
                        <a href='#qualifications' onClick={closeMenu}><b> Qualifications </b></a>
                        {/* <Link to='/'><b> Skills </b></Link> */}
                    </li>
                    <li>
                        <a href='#projects' onClick={closeMenu}><b> Projects </b></a>
                        {/* <Link to='/'><b> Skills </b></Link> */}
                    </li>
                    <li>
                        <a href='#certifications' onClick={closeMenu}><b> Certifications </b></a>
                        {/* <Link to='/'><b> Skills </b></Link> */}
                    </li>
                </ul>
            </nav>

            <div className='changer'>
                <MenuBookOutlined className='menu' onClick={showMenu} />
            </div>
      </div>
    )
}

export default Header;